module.exports = __webpack_public_path__ + "img/Chooffer_logo_small.acf253a6.png";